import { render, staticRenderFns } from "./AddButton.vue?vue&type=template&id=19488555&scoped=true&"
import script from "./AddButton.vue?vue&type=script&lang=js&"
export * from "./AddButton.vue?vue&type=script&lang=js&"
import style0 from "./AddButton.vue?vue&type=style&index=0&id=19488555&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19488555",
  null
  
)

export default component.exports